/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import Spinner from '@atlaskit/spinner';
var spinnerWrapperStyles = css({
  display: 'flex',
  justifyContent: 'center',
  marginTop: "var(--ds-space-800, 64px)"
});
var LoadingState = function LoadingState() {
  return jsx("div", {
    css: spinnerWrapperStyles,
    "data-testid": "ConfigPanelLoading"
  }, jsx(Spinner, {
    size: "small",
    interactionName: "config-panel-spinner"
  }));
};
export default LoadingState;